import { List, Map } from 'immutable';
import { parametric, pathSubscription, subscription } from 'nike-re-framejs';
import { OrderedIndex, orderedIndexToIdsList } from '../indexingUtils';
import { match$$ } from './subs';

const prematchIds$$ = parametric((boxStore, boxId) =>
    subscription(
        (matchesIds: List<String>, liveMatchesIds: List<String>) =>
            matchesIds.filter(matchId => !liveMatchesIds.includes(matchId)),
        pathSubscription(['n1', 'boxStore', boxStore, 'boxes', boxId, 'box', 'sportEventIds'], List()),
        pathSubscription(['n1', 'boxStore', boxStore, 'boxes', boxId, 'box', 'liveSportEventIds'], List())
    )
);
export const tournamentMatchIdsOrdered$$ = parametric((tournamentId, boxStore, boxId) =>
    subscription(
        (tlvMatches: List<OrderedIndex>, prematchIds: List<String>) =>
            orderedIndexToIdsList(tlvMatches).filter(matchId => !prematchIds.includes(matchId)),
        pathSubscription(['turboLive', 'overview', 'tournament2matches', tournamentId], List()),
        prematchIds$$(boxStore, boxId)
    )
);

export const mainBetId$$ = parametric(matchId =>
    subscription(
        (bets: List<OrderedIndex>) => orderedIndexToIdsList(bets)?.first(),
        pathSubscription(['turboLive', 'overview', 'match2bets', matchId])
    )
);

export const matchStatus$$ = parametric(matchId =>
    subscription(match => match?.getIn(['timer', 'status']), match$$(null, matchId))
);

export const matchBetCount$$ = parametric(matchId =>
    subscription((match: Map<String, any>) => match?.get('betCount'), match$$(null, matchId))
);

export const mainBet$$ = parametric(matchId =>
    subscription(
        (mainBetId: string, bets) => bets?.get(mainBetId),
        mainBetId$$(matchId),
        pathSubscription(['turboLive', 'overview', 'bets'])
    )
);
